import "./Footer.css";
import logo from "../../assets/logo.png";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TikTokIcon,
  YouTubeIcon,
} from "../ui/Icons";

const HOSPITAL_LINKS = [
  { label: "About Us", page: "about-us" },
  { label: "Specialties", page: "specialties" },
];

const EXPLORE_LINKS = [
  { label: "Services", page: "services" },
  { label: "Branches", page: "branches" },
];

const SOCIAL = [
  { key: "tiktok", label: "TikTok", Icon: TikTokIcon },
  { key: "youtube", label: "YouTube", Icon: YouTubeIcon },
  {
    key: "linkedin",
    label: "LinkedIn",
    Icon: LinkedInIcon,
    href: "https://www.linkedin.com/in/capital-care-international-hospital-111927393/",
  },
  { key: "facebook", label: "Facebook", Icon: FacebookIcon },
  { key: "instagram", label: "Instagram", Icon: InstagramIcon, href: "https://www.instagram.com/ccih.isb/" },
];

export default function Footer({ setPage }) {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <div className="footer__logo" onClick={() => setPage("home")}>
            <img className="footer__logo-img" src={logo} alt="Capital Care International" />
            <span>Capital Care International</span>
          </div>
          <p>Trusted Care, Compassionate Excellence.</p>

          <div className="footer__social" aria-label="Social links">
            {SOCIAL.map(({ key, label, Icon, href }) =>
              href ? (
                <a
                  key={key}
                  className="footer__social-btn"
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  title={label}
                >
                  <Icon size={16} aria-hidden="true" />
                </a>
              ) : (
                <button key={key} type="button" className="footer__social-btn" aria-label={label} title={label}>
                  <Icon size={16} aria-hidden="true" />
                </button>
              )
            )}
          </div>
        </div>

        <div className="footer__col">
          <h5 className="footer__col-title">Hospital</h5>
          <ul>
            {HOSPITAL_LINKS.map(({ label, page }) => (
              <li key={label}>
                <button type="button" onClick={() => setPage(page)}>
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h5 className="footer__col-title">Help</h5>
          <ul>
            <li>
              <button type="button" onClick={() => setPage("contact")}>
                Contact us
              </button>
            </li>
          </ul>
          <h5 className="footer__col-title" style={{ marginTop: 24 }}>
            Careers
          </h5>
          <ul>
            <li>
              <button type="button" onClick={() => setPage("branches")}>
                Current Openings
              </button>
            </li>
          </ul>
        </div>

        <div className="footer__col">
          <h5 className="footer__col-title">Explore</h5>
          <ul>
            {EXPLORE_LINKS.map(({ label, page }) => (
              <li key={label}>
                <button type="button" onClick={() => setPage(page)}>
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        
      </div>

      <div className="footer__bottom">
        <span>
          Copyright {"\u00A9"} 2026 Capital Care International Hospital. All rights reserved.
        </span>
        <div className="footer__bottom-links">
          <button type="button">Privacy Policy</button>
          <button type="button">Terms of Use</button>
          <button type="button">Disclaimer</button>
          <button type="button">Cancellation &amp; Refund Policy</button>
        </div>
      </div>
    </footer>
  );
}
